import PropTypes from 'prop-types';
import classnames from 'classnames';

const hasWarning = ({ touched, error, warning }) =>
  (touched && error) || (touched && warning);

const Select = ({
  input,
  labelName,
  classNames,
  isRequired,
  isActiveField,
  options,
  disabled,
  meta: { touched, error, warning },
}) => {
  const hasWarningClass = hasWarning({ touched, error, warning });

  const selectContainerClasses = {
    'delicateShadow': true,
    'b--light-blue': isActiveField,
    'b--red': hasWarningClass,
    'b--white': !hasWarningClass && !isActiveField && !disabled,
    'b--none': disabled,
    'bg-black-05': disabled,
    'ba': true,
    'br2': true,
    'relative': true,
    'select': true,
  };

  const selectClasses = {
    'input-reset': true,
    'b--transparent': true,
    'bg-white': !disabled,
    'bg-transparent': disabled,
    'trade-gothic-regular': true,
    'w-100': true,
    'ba': true,
    'f6': true,
    'pl3': true,
    'pv3': true,
    [classNames]: !!classNames,
  };

  return (
    <div className="input pb2 pt1">
      <div
        className={classnames(selectContainerClasses)}
        style={{ cursor: disabled ? 'not-allowed' : 'initial' }}
      >
        <select
          {...input}
          name={labelName}
          required={isRequired}
          disabled={!!disabled}
          className={classnames(selectClasses)}
        >
          {options.map((option) => (
            <option key={`option-${option.value}`} value={option.value}>
              {option.title}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

Select.defaultProps = {
  isRequired: false,
  options: [],
  classNames: null,
  isActiveField: false,
  disabled: false,
};

Select.propTypes = {
  disabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  isActiveField: PropTypes.bool,
  input: PropTypes.object.isRequired, // eslint-disable-line
  labelName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
  classNames: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    warning: PropTypes.string,
  }).isRequired,
};

export default Select;
